/**
 * Runtime configuration.
 *
 * Fetched from /config.json rather than baked in at build time, so one bundle works in dev
 * and production and a redeploy of the site does not require rebuilding to change a pool id.
 */
export interface AppConfig {
  readonly userPoolClientId: string;
  /** Cognito hosted UI origin, e.g. https://unschool-abc123.auth.us-east-1.amazoncognito.com */
  readonly cognitoDomain: string;
  readonly redirectUri: string;
}

let cached: AppConfig | undefined;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;

  const response = await fetch('/config.json', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(
      `Could not load /config.json (${response.status}). The site was deployed without its ` +
        `runtime configuration; re-run scripts/deploy-web.sh.`,
    );
  }

  const parsed = (await response.json()) as Partial<AppConfig>;
  for (const key of ['userPoolClientId', 'cognitoDomain'] as const) {
    if (!parsed[key]) throw new Error(`/config.json is missing ${key}`);
  }

  cached = {
    userPoolClientId: parsed.userPoolClientId as string,
    cognitoDomain: (parsed.cognitoDomain as string).replace(/\/$/, ''),
    redirectUri: parsed.redirectUri ?? `${window.location.origin}/auth/callback`,
  };
  return cached;
}
